<h2 mat-dialog-title>Truck Details</h2>

<mat-dialog-content>

  @if (loading()) {
    <div class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>

      <div class="loading-text">
        Fetching truck details...
      </div>
    </div>
  }

  @if (
    !loading() &&
    (
      !truck() ||
      truck()?.deleted_at ||
      !truck()?.visible
    )
  ) {
    <div class="red-container text-center">
      Truck not found.
    </div>
  } @else if (!loading() && truck()) {

    <div class="details-layout">

      <div class="left-column">


        <!-- Carrier Card (Mobile) -->
        @if(isMobile) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Carrier
              </mat-panel-title>
            </mat-expansion-panel-header>

            {{ truck().carrier?.legal_name }}<br/>

              @if(truck().carrier?.dba_name) {
                dba {{ truck().carrier?.dba_name }}<br/>
              }

              {{ truck().carrier?.phy_city | uppercase }},
              {{ truck().carrier?.phy_state }}
              {{ truck().carrier?.phy_zip }}
              <br/><br/>

              <div class="carrier-info">
                <div>
                  DOT {{ truck().carrier?.dot_number }}<br />

                  {{ truck().carrier?.docket_prefix }}
                  {{ truck().carrier?.docket_number }}<br />

                  {{ getCarrierType(truck().carrier) }}
                </div>

                <button
                  mat-button
                  class="motus-button"
                  (click)="openMotus()"
                  matTooltip="View carrier on MOTUS.gov"
                >
                  <mat-icon>open_in_browser</mat-icon>
                  MOTUS
                </button>
              </div>

              @if(truck().carrier?.phone) {
                <p>P: {{ formatPhone(truck().carrier?.phone) }}</p>
              } @else {
                <p>No phone number available.</p>
              }
          </mat-expansion-panel>
        }

        <!-- Carrier Card (Desktop) -->
        @if(!isMobile) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>Carrier</mat-card-title>
            </mat-card-header>

            <mat-card-content>
              {{ truck().carrier?.legal_name }}<br/>

              @if(truck().carrier?.dba_name) {
                dba {{ truck().carrier?.dba_name }}<br/>
              }

              {{ truck().carrier?.phy_city | uppercase }},
              {{ truck().carrier?.phy_state }}
              {{ truck().carrier?.phy_zip }}
              <br/><br/>

              <div class="carrier-info">
                <div>
                  DOT {{ truck().carrier?.dot_number }}<br />

                  {{ truck().carrier?.docket_prefix }}
                  {{ truck().carrier?.docket_number }}<br />

                  {{ getCarrierType(truck().carrier) }}
                </div>

                <button
                  mat-button
                  class="motus-button"
                  (click)="openMotus()"
                  matTooltip="View carrier on MOTUS.gov"
                >
                  <mat-icon>open_in_browser</mat-icon>
                  MOTUS
                </button>
              </div>

              <br />

              @if(truck().carrier?.phone) {
                <p>P: {{ formatPhone(truck().carrier?.phone) }}</p>
              } @else {
                <p>No phone number available.</p>
              }
              
            </mat-card-content>
          </mat-card>
        }

        <!-- Agent Card (Mobile) -->
        @if(isMobile) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Agent
              </mat-panel-title>
            </mat-expansion-panel-header>

              <p>
                {{ truck().user?.first_name }}
                {{ truck().user?.last_name }}
              </p>

              @if(truck().user?.direct_phone) {
                <p>D: {{ formatPhone(truck().user?.direct_phone) }}</p>
              }

              <p>M: {{ formatPhone(truck().user?.cell_phone) }}</p>

              <p>
                <button
                  mat-button
                  class="motus-button"
                  (click)="showUserEmail()"
                  matTooltip="View email"
                >
                  <mat-icon>email</mat-icon>
                  Show Email
                </button>
              </p>
          </mat-expansion-panel>
        }

        <!-- Agent Card (Desktop) -->
        @if(!isMobile) { 
          <mat-card>
            <mat-card-header>
              <mat-card-title>Agent</mat-card-title>
            </mat-card-header>

            <mat-card-content>
              <p>
                {{ truck().user?.first_name }}
                {{ truck().user?.last_name }}
              </p>

              @if(truck().user?.direct_phone) {
                <p>D: {{ formatPhone(truck().user?.direct_phone) }}</p>
              }

              <p>M: {{ formatPhone(truck().user?.cell_phone) }}</p>

              <p>
                <button
                  mat-button
                  class="motus-button"
                  (click)="showUserEmail()"
                  matTooltip="View email"
                >
                  <mat-icon>email</mat-icon>
                  Show Email
                </button>
              </p>

            </mat-card-content>
          </mat-card>
        }
        
      </div>

      <div class="right-column">

        <mat-card>
<mat-card-header>

            <mat-card-title>Truck</mat-card-title>

            <div class="header-actions">

              <button
                mat-icon-button
                (click)="copyLink()"
                matTooltip="Share link"
              >
                <mat-icon>ios_share</mat-icon>
              </button>

              <button
                mat-icon-button
                (click)="toggleSaved()"
                [matTooltip]="truck()?.is_saved ? 'Remove from saved' : 'Save truck'"
              >
                <mat-icon [class.saved]="truck()?.is_saved">
                  {{ truck()?.is_saved ? 'favorite' : 'favorite_border' }}
                </mat-icon>
              </button>

            </div>

          </mat-card-header>

          <mat-card-content>

            <div class="details-grid">

              <div>
                <strong>Origin</strong>
                <div>{{ truck().origin }}</div>
              </div>

              <div>
                <strong>Available</strong>
                <div>
                  {{ truck().available_start_date | date: 'MM/dd' }}

                  @if(truck().available_start_date !== truck().available_end_date && truck().available_end_date) {
                    - {{ truck().available_end_date | date: 'MM/dd' }}
                  }
                </div>
              </div>

              <div>
                <strong>Axles</strong>
                <div>{{ truck().axle_count }}</div>
              </div>

              <div>
                <strong>Max Weight</strong>
                <div>{{ truck().max_weight | number }} lbs</div>
              </div>

              <div>
                <strong>Well Length</strong>
                <div>{{ toFeetAndInches(truck().well_length) }}</div>
              </div>

              <div>
                <strong>Reference</strong>
                <div>{{ truck().reference }}</div>
              </div>

              @if(truck().min_rate) {
                <div>
                  <strong>Min Rate</strong>
                  <div>{{ truck().min_rate | currency:'USD':'symbol':'1.0-0' }}</div>
                </div>
              }

              @if(truck().min_rpm) {
                <div>
                  <strong>Min RPM</strong>
                  <div>{{ truck().min_rpm | currency:'USD':'symbol' }}</div>
                </div>
              }

              @if(truck().min_distance) {
                <div>
                  <strong>Min Distance</strong>
                  <div>{{ truck().min_distance | number }} mi</div>
                </div>
              }

            </div>

            @if(tags.length > 0) {
              <mat-chip-set class="mt-10">
                @for (tag of tags; track tag) {
                  <mat-chip>{{ tag }}</mat-chip>
                }
              </mat-chip-set>
            }

          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-header>
            <mat-card-title>Notes</mat-card-title>
          </mat-card-header>

          <mat-card-content>
            {{ truck().note || 'No notes provided.' }}
          </mat-card-content>
        </mat-card>

      </div>

    </div>

  }

</mat-dialog-content>

<mat-dialog-actions align="end">

  @if (truck()) {
    <button
      mat-icon-button
      (click)="openInNewTab()"
      matTooltip="Open in new tab"
    >
      <mat-icon>open_in_browser</mat-icon>
    </button>
  }
  
  <button
    mat-icon-button
    mat-dialog-close
    aria-label="Close dialog"
    matTooltip="Close"
    cdkFocusInitial
  >
    <mat-icon>close</mat-icon>
  </button>

</mat-dialog-actions>